import { Provider } from '@angular/core';

import { FeedsDataHttpService } from './abstract';
import { FeedsDataHttpServiceImpl } from './feeds-data-http.service';

export const FeedsDataHttpProvider: Provider = {
	provide: FeedsDataHttpService,
	useClass: FeedsDataHttpServiceImpl,
};
